import { uiActions } from '@/core/state/ui'
import { requestSimulationRun } from './simulationBridge'

/**
 * What the toolbar's Run Simulation button does.
 *
 * The gate is asked here rather than by the caller: `optimization.ts` had to
 * take `requireFeature` as a parameter because the gate's state was per-call
 * Vue refs, and it skipped the check entirely when that parameter was missing.
 * It is a store action since Phase 1F, so the command asks it directly and
 * cannot be called ungated by accident.
 *
 * The gate goes first. Asking the bridge first would tell a user on a locked
 * tier that the map is still loading, which is not their problem.
 */
export async function runSimulation(): Promise<boolean> {
  if (!uiActions.requireFeature('run_simulation', 'Monte Carlo Simulation')) return false
  return requestSimulationRun()
}
